<div class="appointment-scheduler">
  <h2>Schedule an Appointment</h2>

  <form [formGroup]="appointmentForm" (ngSubmit)="onSubmit()">
    <!-- Select Client -->
    <!-- <mat-form-field appearance="fill">
      <mat-label>Select Client</mat-label>
      <mat-select formControlName="client">
        <mat-option *ngFor="let client of clients" [value]="client">{{
          client.name
        }}</mat-option>
      </mat-select>
    </mat-form-field> -->
    <mat-form-field appearance="fill">
      <mat-label>Client Name</mat-label>
      <input matInput type="text" formControlName="client" readonly="true" />
    </mat-form-field>

    <!-- Date Picker -->
    <mat-form-field appearance="fill">
      <mat-label>Pick a Date</mat-label>
      <input matInput [matDatepicker]="picker" formControlName="date" />
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>

    <!-- Time Picker -->
    <mat-form-field appearance="fill">
      <mat-label>Pick a Time</mat-label>
      <input matInput type="time" formControlName="time" />
    </mat-form-field>

    <!-- Dietician Timezone -->
    <mat-form-field appearance="fill">
      <mat-label>Your Timezone</mat-label>
      <mat-select
        formControlName="dieticianTimezone"
        panelClass="custom-select-panel"
      >
        <div class="sticky-input-container">
          <input
            class="input-search"
            placeholder="search timezones"
            type="text"
            (input)="onFilter($event)"
          />
        </div>
        <mat-option *ngFor="let tz of filteredTZ" [value]="tz">{{
          tz
        }}</mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Client Timezone (Auto Display) -->
    <mat-form-field appearance="fill">
      <mat-label>Client's Timezone</mat-label>
      <input matInput [value]="getClientTime()" readonly="true" />
    </mat-form-field>

    <!-- Submit Button -->
    <button
      mat-raised-button
      color="primary"
      type="submit"
      [disabled]="!appointmentForm.valid"
    >
      Book Appointment
    </button>
  </form>
</div>
